'use strict'

import _ from 'underscore'
import Api from '@/components/services/Api'

export default {
  methods: {
    fetchFormData(cb) {
      Api.cecCourses()
        .then(resp => {
          let subcategories = resp.data.subcategories
          let categoriesData = []
          let subcategoriesData = []
          let items = resp.data.items
          let cecsData = []

          _.each(subcategories, subcat => {
            if (!_.contains(categoriesData, subcat.category)) {
              categoriesData.push(subcat.category)
            }

            if (!_.where(subcategoriesData, { pk: subcat.pk }).length) {
              subcategoriesData.push(subcat)
            }
          })

          _.each(items, item => {
            cecsData.push({
              subcategory: item.subcategories,
              name: item.name,
              pk: item.pk,
              level: item.level,
            })
          })

          let result = {
            categories: categoriesData,
            subcategories: subcategoriesData,
            cecs: cecsData,
          }
          cb(null, result)
        })
        .catch(err => {
          cb(err, null)
        })
    },
  },
}



// WEBPACK FOOTER //
// ./src/mixins/CecsMixin.js